var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleStore = function SvgAppleStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#appleStore_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#appleStore_svg__b)",
    d: "M16.5 3.467v9.066A3.46 3.46 0 0 1 13.033 16H3.967A3.46 3.46 0 0 1 .5 12.533V3.467A3.46 3.46 0 0 1 3.967 0h9.066A3.46 3.46 0 0 1 16.5 3.467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.513 9.2H13.5a.733.733 0 1 1 0 1.467h-1.987z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.073 9.2a1.047 1.047 0 0 1 1.054 1.053q0 .215-.08.414H3.5a.733.733 0 0 1 0-1.467zm-.186-4.827v1.28h-.854l-1.04-1.786a.693.693 0 1 1 1.2-.694zm.733 1.24 3.64 6.307a.732.732 0 1 1-1.267.733l-2.2-3.826c-.2-.374-.346-.667-.44-.827a2.005 2.005 0 0 1 .267-2.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.633 9.867H4.94L8.767 3.24a.732.732 0 1 1 1.266.733zM5.74 11.4l-.707 1.24a.731.731 0 1 1-1.266-.733l.52-.907c.161-.08.34-.121.52-.12a1.04 1.04 0 0 1 .933.52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "appleStore_svg__b",
    x1: 8.5,
    x2: 8.5,
    y1: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1d6ff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ac8fc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "appleStore_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgAppleStore;